module.exports = __webpack_public_path__ + "img/DUCZ_LOGO.4dd265ee.png";